import script from "./security.vue?vue&type=script&setup=true&lang=js"
export * from "./security.vue?vue&type=script&setup=true&lang=js"

import "./security.vue?vue&type=style&index=0&id=77c67e3a&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c67e3a"]])

export default __exports__